module.exports = __webpack_public_path__ + "img/notify.9c868d1b.svg";